import { useMemo } from 'react'
import EntitiesSelector from '../EntitiesSelector'

const HospitalDepartmentsSelector = ({ className = '', disabled, hospitalDepartments, multiple = 'default', placeholder = '', style = {}, values, onChange }) => {
  const options = useMemo(() => hospitalDepartments.map(department => ({
    label: department.name,
    value: department.id,
    tooltip: department.name,
    entity: department
  })), [hospitalDepartments])

  return (
    <EntitiesSelector
      className={className}
      disabled={disabled}
      entityOptions={options}
      multiple={multiple}
      placeholder={placeholder}
      style={style}
      values={values}
      onChange={onChange}
    />
  )
}

export default HospitalDepartmentsSelector